export const socialsData = {
    github: 'https://github.com/Swapnilk98',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/swapnil-kapadnis-726263178/',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: 'https://medium.com/@kapadnisswapnil55',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}